import {userService, UserService} from '../services/api/UserService';
import {BaseDataSource} from './BaseDataSource';
import {User, UserFilter} from '../models/User';

export class UserDataSource extends BaseDataSource<User, UserFilter> {

  showOnlyActive: boolean;

  private userService: UserService;

  constructor(showPaginator: boolean) {
    super(showPaginator, userService);
    this.userService = <UserService> this.baseService;
  }

  _loadData(): void {
    console.log('in _loadData');
    console.log(this.filter);

    this.userService.list(this.pageModel, this.filter)
      .then(result => {
        this.onSuccess(result.content);
        this.pageData = result;
      })
      .catch(() => this.onError());
  }

  // _loadData(): void {
  //   if (this.showOnlyActive) {
  //     if (!this.filter) {
  //       this.filter = new UserFilter();
  //     }
  //
  //     this.filter.active = true;
  //     this.userService.list(this.pageModel, this.filter)
  //       .then(result => {
  //         this.onSuccess(result.content);
  //         this.pageData = result;
  //       })
  //       .catch(() => this.onError());
  //   } else {
  //     this.filter.active = null;
  //     super._loadData();
  //   }
  // }
}
